import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  variant?: 'desktop' | 'mobile';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = 'desktop' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ms' ? 'en' : 'ms';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  // Load saved language preference on mount
  React.useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  const isMalay = i18n.language === 'ms';

  return (
    <button
      onClick={toggleLanguage}
      className={`relative inline-flex items-center rounded-full transition-all duration-300 ${
        variant === 'mobile' ? 'h-6 w-12' : 'h-9 w-20'
      } ${isMalay ? 'bg-blue-600' : 'bg-red-600'}`}
      aria-label="Toggle language"
    >
      {/* Sliding toggle indicator */}
      <span
        className={`absolute inline-block transform rounded-full bg-white shadow-lg transition-transform duration-300 ${
          variant === 'mobile' ? 'h-4 w-4 top-1' : 'h-6 w-6 top-1.5'
        } ${
          isMalay
            ? (variant === 'mobile' ? 'translate-x-1' : 'translate-x-1.5')
            : (variant === 'mobile' ? 'translate-x-7' : 'translate-x-12')
        }`}
      />

      {/* Language labels */}
      <span className={`flex w-full justify-between font-bold text-white ${
        variant === 'mobile' ? 'px-1 text-[9px]' : 'px-2 text-xs'
      }`}>
        <span className={`transition-opacity duration-200 ${isMalay ? 'opacity-100' : 'opacity-50'}`}>
          BM
        </span>
        <span className={`transition-opacity duration-200 ${!isMalay ? 'opacity-100' : 'opacity-50'}`}>
          EN
        </span>
      </span>
    </button>
  );
};

export default LanguageSwitcher;
